import React from 'react';
import './previewTop.css';
import Close_Page from '../imageSrc/closePreview.png';
import Consult_Icon from '../imageSrc/consult.png';
import Edit_Icon from '../imageSrc/edit.png'

class PreviewTop extends React.Component {
    constructor(props) {
        super(props)
    }

    handleClosePage = (e) => {
        this.props.closePreview(e);
    };

    handleConsultAction = () => {
        this.handleClosePage();
        this.props.openConsult();
    };

    handleEditAction = () => {
        this.handleClosePage();
        this.props.editContent();
    };

    render(){
        return(
            <div className='div_top'>
                <p className='p_content'>文章预览</p>
                <img onClick={this.handleConsultAction} className='img_consult_style' src={Consult_Icon}/>
                <img onClick={this.handleEditAction} className='img_edit_style' src={Edit_Icon}/>
                <img onClick={this.handleClosePage} className='img_close_style' src={Close_Page}/>
            </div>
        );
    }
}

export default PreviewTop